import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { action_updateEdPConfiguration, action_updateEdPConfigurationErrorValidations, action_updateEdpOnPreparing, action_updateFirstLoad, action_updateFormMode } from '../../../reducers/actions/PAY/edpConfigActions';
import { addPayConfigurationBase, getCheckPayConfigurationExists, getPayConfiguration, getValidatePartidasAbiertas, validateContractEdPOnPreparation, validateContractRolesToEdP } from '../../../services/sPay/edpConfig.service';
import { enum_CONTRACTPARTIE_FORM_MODE } from '../../../common/Dictionaries';
import { isNullUndefinedOrEmpty } from '../../../common/Helpers';


export const useGetEdPConfiguration = (elementId, edpConfigObject, edpConfigGetted, setLRfa) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceCheckPayConfigResponse = await getCheckPayConfigurationExists(elementId);
                let serviceValidateRolesEdPConfigResponse = await validateContractRolesToEdP(elementId);
                
                const responseValidateRolesEdPConfig = serviceValidateRolesEdPConfigResponse.data.data;
    
                if (serviceValidateRolesEdPConfigResponse.data.succeeded) {
                    if (responseValidateRolesEdPConfig) {
                        
                        if (serviceCheckPayConfigResponse.data.succeeded) {
                            const responseCheck = serviceCheckPayConfigResponse.data.data;
        
                            if (serviceCheckPayConfigResponse.data.succeeded && responseCheck) {
                                let serviceGetPayConfigResponse = await getPayConfiguration(elementId);
                                if (serviceGetPayConfigResponse.data.succeeded) {
                                    const responseGet = serviceGetPayConfigResponse.data.data;

                                    let serviceValidatePartidasResponse = await getValidatePartidasAbiertas(elementId);
                                    let messages = [];
                                    if (serviceValidatePartidasResponse.data.succeeded) {
                                        const objPartieValidationData = serviceValidatePartidasResponse.data.data;
                                        if (!objPartieValidationData) {
                                            let serviceValidateHasEdpOnPreparationResponse = await validateContractEdPOnPreparation(elementId);
                                            const responseEdPOnPreparingValidation = serviceValidateHasEdpOnPreparationResponse.data.data;
                                            dispatch(action_updateEdpOnPreparing(responseEdPOnPreparingValidation.result_edp));
        
                                            if (!serviceValidateHasEdpOnPreparationResponse.data.succeeded) {
                                                messages.push('data-lang-msg-operationerror')
                                                dispatch(action_updateFormMode(enum_CONTRACTPARTIE_FORM_MODE.VIEW));
                                            }
                                            else {
                                                if (responseEdPOnPreparingValidation.result_edp) {
                                                    messages.push('data-lang-msg-edpexist')
                                                    dispatch(action_updateFormMode(enum_CONTRACTPARTIE_FORM_MODE.VIEW));
                                                }
                                            }
                                        }
                                        else {
                                            messages.push('data-lang-msg-configcontractpartieopen')
                                            dispatch(action_updateFormMode(enum_CONTRACTPARTIE_FORM_MODE.VIEW));
                                        }

                                        if (responseGet.iteM_CONF_EP_CONTRATO.inconsistente === true) {
                                            const inconsistenteMessages = responseGet.iteM_CONF_EP_CONTRATO.inconsistenteMensaje.split(';')

                                            inconsistenteMessages.forEach(element => {
                                                messages.unshift(element)
                                            });
                                        }

                                        dispatch(action_updateEdPConfigurationErrorValidations(messages));
                                    }
                                    else {
                                        dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']));
                                    }

                                    setLRfa([
                                        {index: 1, configPropertyName: 'rfaUno', roleName: 'RFA', code: 'RFA1', id: 'RFA1', name: 'RFA1', checked: !isNullUndefinedOrEmpty(responseGet.iteM_CONF_EP_CONTRATO.rfaUno)},
                                        {index: 2, configPropertyName: 'rfaDos', roleName: 'RFA', code: 'RFA2', id: 'RFA2', name: 'RFA2', checked: !isNullUndefinedOrEmpty(responseGet.iteM_CONF_EP_CONTRATO.rfaDos)},
                                        {index: 3, configPropertyName: 'rfaTres', roleName: 'RFA', code: 'RFA3', id: 'RFA3', name: 'RFA3', checked: !isNullUndefinedOrEmpty(responseGet.iteM_CONF_EP_CONTRATO.rfaTres)}
                                    ])

                                    dispatch(action_updateEdPConfiguration(responseGet, true));
                                }
                                else {
                                    dispatch(action_updateEdPConfiguration(null, false));
                                    dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']));
                                }
                            }
                            else {
                                let serviceCreateEdPConfigResponse = await addPayConfigurationBase(elementId);
        
                                if (serviceCreateEdPConfigResponse.data.succeeded) {
                                    const responseCreate = serviceCreateEdPConfigResponse.data.data;
        
                                    if (responseCreate.result) {
                                        let serviceGetPayConfigResponse = await getPayConfiguration(elementId);
                                        dispatch(action_updateEdPConfigurationErrorValidations(responseCreate.l_validations));
                                        
                                        if (serviceGetPayConfigResponse.data.succeeded) {
                                            const responseGet = serviceGetPayConfigResponse.data.data;
                                            dispatch(action_updateEdPConfiguration(responseGet, true));

                                            let serviceValidatePartidasResponse = await getValidatePartidasAbiertas(elementId);

                                            if (serviceValidatePartidasResponse.data.succeeded) {
                                                const objPartieValidationData = serviceValidatePartidasResponse.data.data;
                                                if (!objPartieValidationData) {
                                                    let serviceValidateHasEdpOnPreparationResponse = await validateContractEdPOnPreparation(elementId);
                                                    const responseEdPOnPreparingValidation = serviceValidateHasEdpOnPreparationResponse.data.data;
                                                    dispatch(action_updateEdpOnPreparing(responseEdPOnPreparingValidation.result_edp));
                
                                                    if (!serviceValidateHasEdpOnPreparationResponse.data.succeeded) {
                                                        dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']));
                                                        dispatch(action_updateFormMode(enum_CONTRACTPARTIE_FORM_MODE.VIEW));
                                                    }
                                                    else {
                                                        if (responseEdPOnPreparingValidation.result_edp) {
                                                            dispatch(action_updateEdPConfigurationErrorValidations(responseEdPOnPreparingValidation.l_validations));
                                                            dispatch(action_updateFormMode(enum_CONTRACTPARTIE_FORM_MODE.VIEW));
                                                        }
                                                        if (responseEdPOnPreparingValidation.result_inconsistencia) {
                                                            dispatch(action_updateEdPConfigurationErrorValidations(responseEdPOnPreparingValidation.l_validations));
                                                        }
                                                    }
                                                }
                                                else {
                                                    dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-configcontractpartieopen']));
                                                    dispatch(action_updateFormMode(enum_CONTRACTPARTIE_FORM_MODE.VIEW));
                                                }
                                            }
                                            else {
                                                dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']));
                                            }
                                        }
                                        else {
                                            dispatch(action_updateEdPConfiguration(null, false));
                                        }
                                    }
                                    else {
                                        dispatch(action_updateEdPConfigurationErrorValidations(responseCreate.l_validations));
                                        dispatch(action_updateEdPConfiguration(null, false));
                                    }
                                }
                                else {
                                    dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']));
                                }
                            }
                        }
                        else {
                            dispatch(action_updateEdPConfiguration(null, false));
                            dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']));
                        }
                    }
                    else {
                        dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-getedpconfigurationerror']));
                    }
                }
                else {
                    dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-configcontractpartieopen']));
                } 
            }
            catch (error) {
                dispatch(action_updateEdPConfiguration(null, false));
                dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']));
            }

            dispatch(action_updateFirstLoad(true))
        }
        
        if (elementId !== null && edpConfigGetted === null) {
            doIt()
        }
    }, [elementId, edpConfigObject, edpConfigGetted, setLRfa]);
}

export const useCheckIfExistEdPOnPreparation = (elementId, existEdP, setExistEdP) => {    
    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await validateContractEdPOnPreparation(elementId);

                if (serviceResponse.data.succeeded) {
                    setExistEdP(serviceResponse.data.data.result_edp);
                }
                else {
                    setExistEdP(false)
                }
            }
            catch (error) {
                setExistEdP(false)
            }
        }
        
        if (elementId !== null && existEdP === null) {
            doIt()
        }
    }, [elementId, existEdP, setExistEdP]);
}
